"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownError = void 0;
var React = require("react");
var Error_svg_1 = require("../../assets/icons/Error.svg");
var TooltipEnums_1 = require("../Tooltip/TooltipEnums");
var Tooltip_1 = require("../Tooltip");
var constants_1 = require("./constants");
var DropdownError_st_css_1 = require("./DropdownError.st.css");
exports.DropdownError = function (props) {
    return (React.createElement(Tooltip_1.Tooltip, __assign({}, DropdownError_st_css_1.default('root', {}, props), { "data-hook": constants_1.DATA_HOOKS.errorTooltip, placement: "top-end", skin: TooltipEnums_1.TooltipSkin.Error, content: props.errorMessage }),
        React.createElement(Error_svg_1.ReactComponent, { width: constants_1.ICON_SIZE, height: constants_1.ICON_SIZE })));
};
//# sourceMappingURL=DropdownError.js.map